var _style, _g, _polyline, _path, _polyline2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResponsive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Progressive",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-7 9 284 284",
    style: {
      enableBackground: "new -7 9 284 284"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#2458A6;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#2458A6;stroke-width:11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st2{fill:none;stroke:#2458A6;stroke-width:9;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st3{fill:none;stroke:#F2644B;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M194,206.8H26.2c-2.5,0-4.5-2.1-4.5-4.5V72.4c0-2.5,2.1-4.5,4.5-4.5h190.6c2.5,0,4.5,2.1,4.5,4.5 c0,23.6-0.1,47.3-0.1,70.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "151.9,243 91.1,243 99.8,206.8 143.3,206.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 65.1,
    y1: 243,
    x2: 178,
    y2: 243
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M245.8,249.8h-44.6c-2.8,0-5-2.3-5-5v-93.4c0-2.8,2.3-5,5-5h44.6c2.8,0,5,2.3,5,5v93.4 C250.9,247.5,248.6,249.8,245.8,249.8z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 195.3,
    y1: 231.5,
    x2: 249.9,
    y2: 231.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 197.1,
    y1: 164.6,
    x2: 251.7,
    y2: 164.6
  })))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "53.4,138.5 53.4,103.9 86.1,103.9 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M59.2,109.7c12.2,11.4,24.5,22.8,36.7,34.2"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "130.9,161.6 165.5,161.7 165.6,129 "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M161,155.1c-12.8-10.4-25.8-20.8-38.6-31"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsive);
export default __webpack_public_path__ + "static/media/responsive.bf1d3abe93aeff78d3d82d7f34918c97.svg";
export { ForwardRef as ReactComponent };